import axios from "axios";

export const BASE_URL = process.env.REACT_APP_API_URL;
export const API = `${BASE_URL}/customers/api`;
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";

export const colors = {
  red: "#e63946",
  darkRed: "#b91c2c",
  blue: "#2563eb",
  darkBlue: "#1e3a8a",
  activeBlue: "#3b82f6",
  softBlue: "#5b84b3",
  teal: "#0891b2",
  white: "#ffffff",
  lightGrey: "#f1f5f9",
  darkGrey: "#1e3a5f",
  text: "#1e293b",
  border: "#e2e8f0",
  green: "#16a34a",
  orange: "#ea580c",
  amber: "#f59e0b",
  slate: "#64748b",
};

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const PART_LABELS = {
  common: "Common Area",
  warehouse: "Warehouse",
  building: "Building",
  whole: "Whole Building Section",
  unit_group: "Tenant Group",
};

export const PART_FLAGS = {
  common: "has_common_areas",
  warehouse: "has_warehouses",
  building: "has_buildings",
  whole: "has_whole_building_register",
  unit_group: "has_units",
};

export const TYPE_ORDER = ["common", "warehouse", "building", "whole"];

export const NCC_CLASSES = [
  { code: "1a", label: "Class 1a — Single dwelling (house)" },
  { code: "1b", label: "Class 1b — Boarding house / guest house (small)" },
  { code: "2", label: "Class 2 — Apartment building (multi-unit)" },
  { code: "3", label: "Class 3 — Residential building (hotel, motel, hostel)" },
  { code: "4", label: "Class 4 — Dwelling in a commercial building" },
  { code: "5", label: "Class 5 — Office building" },
  { code: "6", label: "Class 6 — Shop / retail / restaurant" },
  { code: "7a", label: "Class 7a — Car park" },
  { code: "7b", label: "Class 7b — Warehouse / storage" },
  { code: "8", label: "Class 8 — Factory / industrial" },
  { code: "9a", label: "Class 9a — Hospital / healthcare" },
  {
    code: "9b",
    label: "Class 9b — Assembly building (school, church, theatre)",
  },
  { code: "9c", label: "Class 9c — Aged care building" },
  { code: "10a", label: "Class 10a — Private garage / shed" },
  { code: "10b", label: "Class 10b — Fence / mast / antenna" },
  { code: "10c", label: "Class 10c — Private bushfire shelter" },
];
